import React, { useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { getNestedProperty } from '../../helpers/getNestedProperty'
import { useSelector } from 'react-redux'

const Email = ({ t, reduxAppProperty, changeObjectPropertyAction, validateEmail, emailError, emailValid, setIsError }) => {
  const [isFocussed, SetIsFocussed] = useState(false)

  const email = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).email)

  const handleEmail = (e) => {
    try {
      let name = e.currentTarget.value
      changeObjectPropertyAction('email', name)
      // validateEmail(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurEmail = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      changeObjectPropertyAction('email', name)
      validateEmail(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const statusClasses = useMemo(() => {
    if (emailValid === '') {
      return 'ns-form-group'
    } else if (emailValid === true) {
      return 'ns-form-group'
    } else {
      return 'ns-form-group ns-form-group-message-error'
    }
  }, [emailValid])

  return (
    <div className={[statusClasses, styles['fields_margin']].join(' ')}>
      <div className="ns-label-wrapper">
        <label className="ns-label" htmlFor="Email">
          {t('contact_information.email')}
        </label>
      </div>
      {/* <div id="email-hint" className="ns-hint">
                    {t('contact_information.your_confirmation')}
                </div> */}
      {emailValid === true || emailValid === '' ? null : (
        <span id="email-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
          <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
          <span className="ns-visually-hidden">{t('shared.error')}</span> {t(emailError)}
        </span>
      )}
      <div style={{ display: 'flex', overflow: 'auto' }}>
        <input
          className={['fw-20', emailValid !== true && emailValid !== '' ? 'ns-input--error' : ''].join(' ')}
          id="Email"
          name="Email"
          type="text"
          style={{ flexGrow: 1, minWidth: '3em' }}
          aria-describedby="email"
          onChange={handleEmail}
          // onBlur={onBlurEmail}
          onFocus={() => SetIsFocussed(true)}
          value={email}
          autoComplete="off"
          maxLength="50"
        />
        {/* {emailValid === true && (
          <div style={{ display: 'inline-flex', marginLeft: '1rem', alignItems: 'center' }}>
            <i className="fa fa-check-circle fa-lg" aria-hidden="true"></i>
          </div>
        )} */}
      </div>
    </div>
  )
}

export default withTranslation('common')(Email)
